import Spin from '@/components/basic/spin';
import theme from '@/style';
import React from 'react';
import Header from './result-header';
import ResultItem from './result-item';
import {DiceResultItem, pageDiceResult} from '../../dice-service';
import NoData from '@/components/basic/error-pages/no-data';
import Page from '@/components/business/games/page';

const pageSize = 10;

const DiceResult = ({
  configId,
  isActive = false,
  refreshCode = 0,
}: {
  configId?: number;
  isActive?: boolean;
  refreshCode?: number;
}) => {
  const [total, setTotal] = React.useState(0);
  const [firstLoad, setFirstLoad] = React.useState(false);
  const [list, setList] = React.useState<DiceResultItem[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [initPage, setInitPage] = React.useState(1);
  const getList = async (id: number, page: number = 1) => {
    try {
      setLoading(true);
      const res = await pageDiceResult({
        configId: id,
        pageNo: page,
        pageSize,
      });
      if (res) {
        setTotal(res.totalSize);
        setList(res.content);
      }
    } finally {
      setLoading(false);
      setFirstLoad(false);
    }
  };

  React.useEffect(() => {
    if (configId && isActive) {
      getList(configId).then();
    }
  }, [configId, isActive]);

  React.useEffect(() => {
    if (refreshCode && isActive && configId) {
      getList(configId).then();
      setInitPage(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshCode]);

  return (
    <Spin
      loading={firstLoad || loading}
      style={[theme.fill.fill, theme.padding.topl]}>
      <Header />
      {!firstLoad && !loading && list && list.length === 0 ? <NoData /> : null}
      {list.map((item, index) => (
        <ResultItem
          index={index}
          key={index}
          {...item}
          isLast={list.length === index + 1}
        />
      ))}
      {total > 0 ? (
        <Page
          page={initPage}
          total={total}
          pageSize={pageSize}
          onPageChange={p => {
            if (configId) {
              setInitPage(p);
              getList(configId, p).then();
            }
          }}
        />
      ) : null}
    </Spin>
  );
};

export default React.memo(DiceResult);
